// Play/pause button for the "today" view task row
import { IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import { translate as t } from '@/i18n/useT';
import { getOnboardingHighlightSx } from '@/features/onboarding/utils/onboardingHighlightSx';
import {
  taskPauseButtonSx,
  taskPauseIconSx,
  taskPlayButtonSx,
  taskPlayIconSx,
} from '@/components/ui/taskVisualTokens';

const stopHandlers = (stopAllPropagation) => ({
  onPointerDown: stopAllPropagation,
  onPointerUp: stopAllPropagation,
  onMouseDown: stopAllPropagation,
  onMouseUp: stopAllPropagation,
  onTouchStart: stopAllPropagation,
  onTouchEnd: stopAllPropagation,
});

/** Play/pause button — sits in the rail, before the checkbox, in the "today" view. */
export const TaskFocusButton = ({
  task,
  isFocused,
  showPlayButton,
  user,
  handleStartFocus,
  stopFocus,
  stopAllPropagation,
  highlight = false,
}) => {
  const handlers = stopHandlers(stopAllPropagation);

  if (showPlayButton && !isFocused && task.status !== 'Backlog') {
    return (
      <IconButton
        size="small"
        tabIndex={-1}
        data-no-dnd="true"
        data-testid="task-focus-play"
        {...handlers}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (user && handleStartFocus) handleStartFocus(task.id, user.uid);
        }}
        aria-label={t('focus.start', 'Start Focus')}
        title={t('focus.start', 'Start Focus')}
        sx={{ ...taskPlayButtonSx, ...getOnboardingHighlightSx(highlight) }}
      >
        <PlayArrowIcon sx={taskPlayIconSx} />
      </IconButton>
    );
  }
  if (isFocused) {
    return (
      <IconButton
        size="small"
        tabIndex={-1}
        data-no-dnd="true"
        {...handlers}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (stopFocus) stopFocus();
        }}
        aria-label={t('focus.stop', 'Stop Focus')}
        title={t('focus.stop', 'Stop Focus')}
        sx={taskPauseButtonSx}
      >
        <PauseIcon sx={taskPauseIconSx} />
      </IconButton>
    );
  }
  return null;
};
